import { formModeEnum } from '@/types/general';

import { settingsBreadcrumbs } from '../settings-breadcrumbs';

const usersCrumb = {
  label: 'global.sidebar.users_trans',
  route: { name: 's-users' },
};

const users_routes = [
  {
    path: 'users',
    name: 'users',
    meta: {
      permissions: 'read-users',
    },
    children: [
      {
        path: '',
        name: 's-users',
        component: () => import('@/views/System/Settings/Users/UsersList.vue'),
        meta: {
          permissions: 'read-users',
          breadcrumbs: settingsBreadcrumbs(usersCrumb),
        },
      },
      {
        path: 'add',
        name: 's-users-add',
        component: () => import('@/views/System/Settings/Users/Components/UserForm.vue'),
        meta: {
          formType: formModeEnum.ADD,
          permissions: 'write-users',
          breadcrumbs: settingsBreadcrumbs(usersCrumb),
        },
      },
      {
        path: 'edit/:id',
        name: 's-users-edit',
        component: () => import('@/views/System/Settings/Users/Components/UserForm.vue'),
        meta: {
          formType: formModeEnum.EDIT,
          permissions: 'update-users',
          breadcrumbs: settingsBreadcrumbs(usersCrumb),
        },
      },
    ],
  },
];

export default users_routes;
